import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { Profile } from '../../models/profile';
import { UserLogicService } from '../../services/user.logic.service';
import { EEAOutputProjectSummaryResultSurfaceWaterApiService, EraSmeSelectionStatus } from '../../services/out-put-project/eea-output-project-step1n2-summary-result.api.service';
import { Constants } from '../../utils/constants';

interface StepStatus {
  label: string;
  selected: boolean;
  errorMessage?: string;
}

@Component({
  selector: 'sme-notification',
  templateUrl: './sme-notification.component.html',
  styleUrls: ['./sme-notification.component.css']
})
export class SmeNotificationComponent implements OnInit {
  @Input() projectPk: number = 0;
  @Output() onCloseEvent = new EventEmitter<void>();

  visible: boolean = true;
  suggestions: Profile[] = [];
  selectedRecipients: Profile[] = [];
  notes: string = '';

  stepStatuses: StepStatus[] = [
    { label: Constants.SCENARIO_FOCUS.STEP1, selected: false },
    { label: Constants.SCENARIO_FOCUS.STEP2, selected: false },
    { label: Constants.SCENARIO_FOCUS.STEP3, selected: false },
    { label: Constants.SCENARIO_FOCUS.STEP4, selected: false }
  ];

  constructor(
    private userLogicService: UserLogicService,
    private surfaceWaterApiService: EEAOutputProjectSummaryResultSurfaceWaterApiService
  ) {}

  ngOnInit(): void {
    if (this.projectPk) {
      this.loadEraSmeSelectionStatus();
    }
  }

  private loadEraSmeSelectionStatus(): void {
    this.surfaceWaterApiService.getEraSmeSelectionStatus(this.projectPk).subscribe({
      next: (statuses: EraSmeSelectionStatus[]) => {
        const selectedSteps = new Set(statuses.map(s => s.scenarioFocus));
        this.stepStatuses.forEach(step => step.selected = selectedSteps.has(step.label));
        this.applyStepDependencyValidation();
      },
      error: () => {}
    });
  }

  private applyStepDependencyValidation(): void {
    const step3 = this.stepStatuses.find(s => s.label === Constants.SCENARIO_FOCUS.STEP3);
    const step4 = this.stepStatuses.find(s => s.label === Constants.SCENARIO_FOCUS.STEP4);
    if (step3 && step4 && step4.selected && !step3.selected) {
      step3.errorMessage = 'You must save Step3 PECs before send Step4';
    } else if (step3) {
      step3.errorMessage = undefined;
    }
  }

  searchUsers(event: AutoCompleteCompleteEvent): void {
    this.userLogicService.searchUsers(event.query).subscribe({
      next: (users) => this.suggestions = users,
      error: () => this.suggestions = []
    });
  }

  get isSendDisabled(): boolean {
    const hasSelectedStep = this.stepStatuses.some(step => step.selected);
    const hasStepError = this.stepStatuses.some(step => !!step.errorMessage);
    return this.selectedRecipients.length === 0 || !hasSelectedStep || hasStepError;
  }

  close(): void {
    this.onCloseEvent.emit();
  }
}
